// extracted by mini-css-extract-plugin
export default {"moreDetails":"SalarySlip_moreDetails__4wgdY","innerButton":"SalarySlip_innerButton__VzZoB"};